export default __webpack_public_path__ + "static/media/dgl-with-boy-circle.e1ca3655.png";